import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

/**
 * Custom hook to track a timestamp and return a relative "time ago" string.
 * Updates every minute to keep the display current.
 * @returns An object containing:
 *  - setTime: Function to set the timestamp to track.
 *  - timeAgo: String representing the relative time from the set timestamp (e.g., "2 minutes ago").
 */
export const useTimeAgo = () => {
  const [time, setTime] = useState<string>('');
  const [timeAgo, setTimeAgo] = useState<string>('');

  useEffect(() => {
    if (!time) {
      setTimeAgo('');
      return;
    }

    setTimeAgo(dayjs(time).fromNow());
    const intervalId = setInterval(() => {
      setTimeAgo(dayjs(time).fromNow());
    }, 1000 * 60);
    return () => clearInterval(intervalId);
  }, [time]);

  return { setTime, timeAgo };
};
